import { useState, useEffect, useCallback } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from './alert-dialog';
import { registerConfirm } from '../../lib/confirm';

/**
 * ConfirmHost — se monta UNA vez en App y atiende todas las llamadas a
 * confirmDialog(). Presenta un AlertDialog temado (accesible: foco atrapado,
 * ESC, roles ARIA correctos vía Radix) en lugar del confirm() nativo.
 */
export default function ConfirmHost() {
  const [state, setState] = useState(null); // { opts, resolve }

  useEffect(() => {
    registerConfirm((opts, resolve) => setState({ opts, resolve }));
  }, []);

  const finish = useCallback((value) => {
    setState((s) => {
      if (s) s.resolve(value);
      return null;
    });
  }, []);

  const opts = state?.opts || {};
  const danger = !!opts.danger;

  return (
    <AlertDialog open={!!state} onOpenChange={(open) => { if (!open) finish(false); }}>
      <AlertDialogContent className="bg-zinc-950 border-zinc-800">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-xl text-white uppercase">
            {opts.title || 'Confirmar'}
          </AlertDialogTitle>
          {opts.message && (
            <AlertDialogDescription className="text-zinc-400">
              {opts.message}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => finish(false)}
            className="btn-secondary mt-0"
          >
            {opts.cancelLabel || 'Cancelar'}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => finish(true)}
            className={danger
              ? 'bg-red-600 hover:bg-red-500 text-white'
              : 'btn-primary'}
          >
            {opts.confirmLabel || 'Confirmar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
